export default __webpack_public_path__ + "static/media/successful.0f344b8e.svg";